module.exports = __webpack_public_path__ + "4169ad230fdccf2f76e9d41e41b51866.png";